import { BillingHistoryInvoice } from '~/modules/settings/views/BillingHistory/helpers';

export type BillingHistoryItemApi = {
  invoice_id: string;
  order_id: string;
  date: string;
  amount: number;
  currency: string;
};

export type BillingHistoryApiResponse = {
  data?: BillingHistoryItemApi[];
};

export type BillingOrderDetailApi = {
  order_id: string;
  charged_at: string;
  amount: number;
  currency: string;
  description: string;
  customer_email: string;
  payment_card_brand: string;
  payment_card_last4: string;
  merchant_legal_name: string;
  merchant_address: string;
  merchant_tax_id: string;
};

export type BillingOrderDetailApiResponse = {
  data?: BillingOrderDetailApi;
};

const splitMerchantAddress = (
  address: string,
): Pick<
  BillingHistoryInvoice,
  'merchantAddressFirstLine' | 'merchantAddressRemainingLines'
> => {
  const lines = address
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  return {
    merchantAddressFirstLine: lines[0] ?? '',
    merchantAddressRemainingLines: lines.slice(1),
  };
};

function mapBillingHistoryItem(
  i: BillingHistoryItemApi,
): BillingHistoryInvoice {
  return {
    invoiceId: i.invoice_id,
    orderId: i.order_id,
    chargedAt: i.date,
    amountMinor: i.amount,
    currency: i.currency,
    description: '',
    customerEmail: '',
    paymentCardBrand: '',
    paymentCardLast4: '',
    merchantLegalName: '',
    merchantAddressFirstLine: '',
    merchantAddressRemainingLines: [],
    merchantTaxId: '',
  };
}

export function mapBillingHistoryResponse(
  raw: BillingHistoryApiResponse,
): BillingHistoryInvoice[] {
  return (raw.data ?? []).map(mapBillingHistoryItem);
}

export function mapBillingOrderDetail(
  raw: BillingOrderDetailApiResponse,
  sourceInvoice: BillingHistoryInvoice,
): BillingHistoryInvoice | null {
  if (!raw.data) return null;

  const merchantAddress = splitMerchantAddress(raw.data.merchant_address);
  return {
    invoiceId: sourceInvoice.invoiceId,
    orderId: raw.data.order_id,
    chargedAt: raw.data.charged_at,
    amountMinor: raw.data.amount,
    currency: raw.data.currency,
    description: raw.data.description,
    customerEmail: raw.data.customer_email,
    paymentCardBrand: raw.data.payment_card_brand,
    paymentCardLast4: raw.data.payment_card_last4,
    merchantLegalName: raw.data.merchant_legal_name,
    merchantAddressFirstLine: merchantAddress.merchantAddressFirstLine,
    merchantAddressRemainingLines:
      merchantAddress.merchantAddressRemainingLines,
    merchantTaxId: raw.data.merchant_tax_id,
  };
}
